import { render, staticRenderFns } from "./crowdfunding.vue?vue&type=template&id=de751490&scoped=true"
import script from "./crowdfunding.vue?vue&type=script&lang=js"
export * from "./crowdfunding.vue?vue&type=script&lang=js"
import style0 from "./crowdfunding.vue?vue&type=style&index=0&id=de751490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de751490",
  null
  
)

export default component.exports